import configService from './configservice';
import { sbToastr } from 'shipbob_design_system';
import { getAuthService } from '@/auth';
import { examplesResponse } from './example/packagingSlipExample';

async function handleApiResponse(response) {
  switch (response.status) {
    case 200:
      return response.data;
    case 401:
      await getAuthService().logout();
      break;
    default:
      throw new Error(`Unable to process the request: ${response.status}`);
  }
}
export default class FulfillmentCustomizationService {
  constructor(axiosInstance) {
    this.axiosInstance = axiosInstance;
  }
  getPackagingSlipConfiguration = async () => {
    try {
      let response = await this.axiosInstance
      .request('GET', configService.FulfillmentCustomizationApiUrl + '/api/PackingSlipSettings');
      return handleApiResponse(response);
    } catch (error) {
      sbToastr.error(`Error Unable to Get Packaging Slip Configuration`)
    }
  }
  getPackagingSlipConfigurations = () => {
    // TODO: There is a task to create and add the correct endpoint
      return examplesResponse;
    
  }

  updatePackagingSlipConfiguration = async (data) => {
    try {
      let response = await this.axiosInstance
      .request('PUT', configService.FulfillmentCustomizationApiUrl + '/api/PackingSlipSettings', undefined, data);
      return handleApiResponse(response);
    } catch (error) {
      sbToastr.error(`Unable to Save Packaging Slip Configuration`)
    }
  }

  deletePackagingSlipConfiguration = async (data) => {
   // TODO: There is a task to create and add the correct endpoint
   return data;
  }
  getPackagingSlipLogo = async () => {
    try {
      let response = await this.axiosInstance
      .request('GET', configService.FulfillmentCustomizationApiUrl + '/api/PackingSlipSettings/logo');
      return handleApiResponse(response);
    } catch (error) {
      sbToastr.error(`Error Unable to Get Packaging Slip Configuration`)
    }
  }
  updatePackagingSlipLogo = async (data) => {
    try {
      let response = await this.axiosInstance
      .request('PUT', configService.FulfillmentCustomizationApiUrl + '/api/PackingSlipSettings/logo', undefined, data);
      return handleApiResponse(response);
    } catch (error) {
      sbToastr.error(`Unable to Save Packaging Slip Configuration`)
    }
  }
  deletePackagingSlipLogo = async () => {
    try {
      let response = await this.axiosInstance
      .request('DELETE', `${configService.FulfillmentCustomizationApiUrl}/api/PackingSlipSettings/logo`);
      return handleApiResponse(response);
    } catch (error) {
      sbToastr.error(`Unable to Save Packaging Slip Configuration`)
    }
  }
  getPackagingSlipSettings = async () => {
    try {
      let response = await this.axiosInstance
      .request('GET', configService.FulfillmentCustomizationApiUrl + '/api/PackingSlipSettings/custom');
      return handleApiResponse(response);
    } catch (error) {
      sbToastr.error(`Error Unable to Get Packaging Slip Settings`)
    }
  }
  updatePackagingSlipSettings = async (data) => {
    try {
      let response = await this.axiosInstance
      .request('PUT', configService.FulfillmentCustomizationApiUrl +
        '/api/PackingSlipSettings/custom', undefined, data);
      return handleApiResponse(response);
    } catch (error) {
      sbToastr.error(`Unable to Save Packaging Slip Settings`)
    }
  }
  getCustomizationPermission = async () => {
    try {
      let response = await this.axiosInstance
      .request('GET', configService.FulfillmentCustomizationApiUrl +
        '/api/PackingSlipSettings/customization/permission');
      return handleApiResponse(response);
    } catch (error) {
      sbToastr.error(`Error Unable to Get Customization permission`)
    }
  }
  getBrandedTrackingPageStatus = async (userid) => {
    try {
      let response = await this.axiosInstance
      .request('GET', configService.ShipmentTrackingApiUrl +
        `/api/v1/user/${userid}/branded-tracking`);
        if(response.status === 404) {
          return null;
        }
     return handleApiResponse(response);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return null;
      }
      else {
        sbToastr.error(`Error Unable to Get Branded Tracking Page Status`)
      }
    }
  }
}